module.exports = __webpack_public_path__ + "img/manu_jain.2a952171.jpg";